import { render, staticRenderFns } from "./parkingScanDetail.vue?vue&type=template&id=2721d99a&scoped=true&"
import script from "./parkingScanDetail.vue?vue&type=script&lang=js&"
export * from "./parkingScanDetail.vue?vue&type=script&lang=js&"
import style0 from "./parkingScanDetail.vue?vue&type=style&index=0&id=2721d99a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2721d99a",
  null
  
)

export default component.exports